import React, { Component } from 'react';
import { Input, Select, message } from 'antd';
import { withRouter } from 'react-router-dom';
import emitter from '../util/emitter';
// import smart from '../assets/smart-select.png';
import { STATIC_RESOURCE } from '../origin';
// import { SearchOutlined } from '@ant-design/icons';
import './index.less';

const { Search } = Input;
const { Option } = Select;
const smart_config = {
  zh_title: '智能选品',
  en_title: 'Smart Selection'
};
const search_text_config = {
  zh_title: '搜索',
  en_title: 'Search'
};
const search_placeholder_config = {
  zh_title: '请输入关键词',
  en_title: 'Please Enter A Keyword'
};
const search_config = [{ zh_title: '商品', en_title: 'Product', value: '1', }, { zh_title: '商家', en_title: 'Seller', value: '2' },{ zh_title: 'ERP编码', en_title: 'ERP code', value: '3' },];

class CpSearchBar extends Component {
  searchTypeChanged = (value) => {
    this.props.searchTypeChanged(value);
  }

  inputChanged = (e) => {
    let value = e.target.value;
    this.props.searchValueChanged(value);
  }

  toSearch = () => {
    const { searchType = '1', searchValue = '', searchProduct } = this.props;
    if (searchProduct && typeof searchProduct === 'function') {
      searchProduct();
    } else {
      emitter.emit('goHome');
      let url = searchValue ? `/basic/home/${searchValue}/${searchType}` : `/basic/home`;
      this.props.history.push(url);
    }
  }

  openUrl = () => {
    const account = window.localStorage.getItem('account');
    const group_type = window.localStorage.getItem('group_type');
    if (`${group_type}` === '1') {
      window.open(`https://gt.cprd.tech/#/domestic_e_commerce_platform/list?username=${account}`);
    } else {
      message.info('您暂无权限访问');
    }
  }

  render() {
    const { searchType = '1', searchValue = '' } = this.props;
    return (
      <div className="cp-search">
        <Input.Group compact>
          <Select value={searchType} onChange={this.searchTypeChanged}>
            {/* <Option value="1">商品</Option>
            <Option value="2">商家</Option> */}
            {search_config.map(item => <Option key={item.value} value={item.value}>{item[`${this.props.language || 'zh_'}title`]}</Option>)}
          </Select>
          <Search
            value={searchValue}
            placeholder={search_placeholder_config[`${this.props.language || 'zh_'}title`]}
            enterButton={search_text_config[`${this.props.language || 'zh_'}title`]}
            size="large"
            onChange={(e) => { this.inputChanged(e); }}
            onSearch={this.toSearch}
          // prefix={<SearchOutlined  style={{ fontSize: 16,}}/>}
          />
        </Input.Group>
        <div onClick={this.openUrl} className='cp-search-smart-container'>
          <img className='smart-select-img' src={`${STATIC_RESOURCE}/cp_purchase/index/smart.png`} alt='' />
          <span>{smart_config[`${this.props.language || 'zh_'}title`]}</span>
        </div>
      </div>
    );
  }
}

export default withRouter(CpSearchBar);
